import React from 'react';
import Portal from '@utils/portal';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { CloseIconAtom } from '@atoms/icon-atoms/nav-icon-atoms';
import { ModalProps } from './modal.types';

const Modal: React.FC<ModalProps> = ({
  open,
  children,
  onClose,
  className,
}) => {
  if (!open) return null;

  return (
    <Portal>
      <div className={className}>
        <div
          className="modal-overlay"
          onClick={onClose}
          onKeyDown={onClose}
          role="button"
          tabIndex={0}
          data-label="close"
          aria-label="close"
        />
        <div className="modal-container">
          <div
            className="modal-close"
            onClick={onClose}
            onKeyDown={onClose}
            role="button"
            tabIndex={0}
            data-label="close"
            aria-label="close"
          >
            <CloseIconAtom />
          </div>
          {children}
        </div>
      </div>
    </Portal>
  );
};

const StyledModal = styled(Modal)`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${vars.modalTransparentGrey};
    mix-blend-mode: multiply;
    z-index: 1000;
  }
  .modal-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 1.12s ease-out;
    background-color: ${vars.white};
    z-index: 1000;

    .modal-close {
      position: absolute;
      top: 2rem;
      right: 2rem;
      cursor: pointer;
    }
  }
`;

export default StyledModal;
